module.exports = __webpack_public_path__ + "img/9788994368023.953610f0.jpg";